import { render, staticRenderFns } from "./ListOpportunities.vue?vue&type=template&id=f34c6d96&scoped=true&"
import script from "./ListOpportunities.vue?vue&type=script&lang=js&"
export * from "./ListOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./ListOpportunities.vue?vue&type=style&index=0&id=f34c6d96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f34c6d96",
  null
  
)

export default component.exports